import {useAnnotationModeStore} from '../store/AnnotationModeStore';
import {useCanViewAnnotations} from './useCanViewAnnotations';
import {useIsAnnotationModeAvailable} from './useIsAnnotationModeAvailable';

/** The store flag alone is not enough: it stays on after a surface stops qualifying. */
export function useIsAnnotationModeActive(isSessionOnlyMode = false): boolean {
  const isAnnotationModeOn = useAnnotationModeStore((state) => state.isAnnotationModeOn);
  const isAssignmentAvailable = useIsAnnotationModeAvailable();
  const isSessionOnlyAvailable = useCanViewAnnotations();

  return isAnnotationModeOn && (isSessionOnlyMode ? isSessionOnlyAvailable : isAssignmentAvailable);
}
